// extracted by mini-css-extract-plugin
export default {"noUser":"authentication_noUser__EnGZI","title":"authentication_title__LAE55","subTitle":"authentication_subTitle__abK4s","login":"authentication_login__LfjY3"};